import { Avatar, Button, Col, Input, Row, Text, TextEditor } from 'components';
import { Api, theme } from 'lib';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { DatePicker, SearchUsers } from 'screens/Admin/components';

import { OrderList } from './';

const Order = ({ closeModal, order, setDataId }) => {
  const [owner, setOwner] = useState(null),
    [orderItems, setOrderItems] = useState([]),
    [selectedOrder, setSelectedOrder] = useState(0),
    [createdAt, setCreatedAt] = useState(0),
    [errors, setErrors] = useState([]),
    [notes, setNotes] = useState(''),
    isEditing = !!order,
    dispatch = useDispatch(),
    price = order?.total.discountedInUSD / 100;

  useEffect(() => {
    setOwner(order?.owner || null);
    setOrderItems(order?.orders || []);
    setCreatedAt(order?.createdAt ? new Date(order?.createdAt) : new Date());
    setSelectedOrder(0);
    setNotes(order?.notes || '');
  }, [order]);

  function handleChangeItem(item, opt) {
    setOrderItems(
      orderItems.map((x, i) => {
        if (x._id !== item._id) return x;

        const newItem = {
          ...x,
          ...opt
        };

        setSelectedOrder(newItem);

        return newItem;
      })
    );
  }

  async function submit() {
    let newErrs = [];
    if (!owner) newErrs.push({ input: 'owner', err: 'Required' });
    if (!orderItems.length) newErrs.push({ input: 'media', err: 'At least one order is required' });

    setErrors(newErrs);
    if (newErrs.length) return;

    dispatch({ type: 'LOADING_BUTTON', payload: 'addOrder' });

    const filteredOrderItems = orderItems
      .filter((x, i) => x.status !== order.orders[i].status)
      .map((x) => ({
        _id: x._id,
        status: x.status
      }));

    const data = {
      owner: owner._id,
      orderItems,
      createdAt,
      notes,
      _id: order?._id
    };

    const res = await Api.post('/admin/updateOrder', data);
    if (!res) return dispatch({ type: 'LOADING_BUTTON', payload: null });

    dispatch({
      type: order?._id ? 'ADMIN_EDIT_ORDER' : 'ADMIN_ADD_ORDER',
      payload: {
        ...res,
        owner: owner
      }
    });

    dispatch({
      type: 'HANDLE_RES',
      payload: { res: order?._id ? 'Order edited.' : 'Order published.' }
    });

    dispatch({ type: 'LOADING_BUTTON', payload: null });
    setDataId(res._id);
    closeModal();
  }

  return (
    <Col start between ht="calc(100% - 55px)" pad="0 24px">
      <Col wid="100%" noFlex>
        <Row between marg="24px 0 0">
          <Text marg="0 16px 4px" b2 med>
            Owner
          </Text>
        </Row>

        {owner && (
          <Row noFlex start marg="0 0 0">
            <Row center between wid="100%" pad="0 0">
              <Row noFlex center>
                <Avatar small user={owner} />

                <Col marg="0 0 0 8px" noFlex>
                  <Text>{owner?.name}</Text>

                  <Text c1 col={theme.GREY_60}>
                    @{owner?.username}
                  </Text>
                </Col>
              </Row>
            </Row>
          </Row>
        )}

        <SearchUsers
          wid="calc(100% - 48px)"
          selected={owner}
          handleSelect={setOwner}
          noRounded
          error={errors.find((x) => x.input === 'owner')}
        />

        <OrderList orderItems={orderItems} handleChange={handleChangeItem} price={price} />

        <TextEditor
          onChange={(val) => setNotes(val)}
          value={notes}
          title="Order notes"
          marg="24px 0 0"
        />

        <Input
          disabled
          currency
          prefix="$"
          defaultValue={0}
          marg="24px 0 0"
          title="Price"
          placeholder="$"
          value={price}
          onValueChange={(e) => null}
        />

        <Text marg="24px 16px 4px" b2 med>
          Created at
        </Text>

        <DatePicker
          disabled
          selected={createdAt}
          handleSelect={setCreatedAt}
          title={!createdAt && 'Now'}
          marg="0 16px 0"
        />
      </Col>

      <Row pad="24px 0">
        <Button big text="Cancel" onClick={closeModal} marg="0 24px 0 0" bordered />

        <Button
          big
          onClick={submit}
          text={isEditing ? 'Edit' : 'Publish'}
          bg={theme.SECONDARY}
          action="addOrder"
        />
      </Row>
    </Col>
  );
};

export default Order;
